import { atom } from "recoil";

const locationStateAtom = atom({

    key:"locationState",
    default: {}

});

export default locationStateAtom;